
import { computed, defineComponent } from 'vue'

const getRandomWidth = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min + 1)) + min

export default defineComponent({
  name: 'VulnerabilityListItemSkeleton',
  setup() {
    const identifierWidth = computed(() => getRandomWidth(108, 128)) // 128px (w-32) - 20px
    const summaryWidth = computed(() => getRandomWidth(216, 256)) // 256px (w-64) - 40px
    const packageWidth = computed(() => getRandomWidth(88, 128)) // 128px (w-32) - 40px

    return { identifierWidth, summaryWidth, packageWidth }
  }
})
